import { AgmMap, MapsAPILoader, MouseEvent } from '@agm/core';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'location-picker',
  templateUrl: './location-picker.component.html',
  styleUrls: ['./location-picker.component.scss']
})
export class LocationPickerComponent implements OnInit {


  @Input() form: FormGroup
  @Input() controlName: string
  @Input() label: string
  @Input() value: string
  @Input() lat: any
  @Input() lng: any
  @Input() zoom: number = 8
  @Input() class: string = 'flex-auto col-12 ml-2 mr-2 gt-xs:pr-3 mb-1'


  
  public get latitude() : any {
    return this.form.get(this.controlName).value != null&& this.form.get(this.controlName).get('coordinates')?.value?.length ===2? this.form.get(this.controlName).value.coordinates[0]: this.lat
  }
  
  public get longitude() : any {
    return this.form.get(this.controlName).value != null && this.form.get(this.controlName).get('coordinates')?.value?.length ===2? this.form.get(this.controlName).value.coordinates[1]: this.lng
  }
  

  constructor(private apiloader: MapsAPILoader,private route: ActivatedRoute) { }
  locations: any[];

  ngOnInit(): void {
    if(this.route.snapshot.paramMap.get('id')){
      this.form.get(this.controlName).valueChanges.subscribe(value=>{
        if (value && value.coordinates){

          this.lat = value.coordinates.at(0)
          this.lng = value.coordinates.at(1)
  
          this.agmMap.fitBounds = true;
        }else{

          this.getCurrentLocation()
        }
      })
    }else{
      this.getCurrentLocation()
    }

    
  }

  @ViewChild(AgmMap, { static: true }) public agmMap: AgmMap;
  getCurrentLocation() {
    if (navigator.geolocation && !this.lat && !this.lng) {
      navigator.geolocation.getCurrentPosition((position: any) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
        }
      })
    }
  }



  setLocation(evt: MouseEvent) {
    this.lat = evt.coords.lat
    this.lng = evt.coords.lng
    this.form?.get(this.controlName).setValue({
      type: 'Point',
      coordinates: [evt.coords.lat, evt.coords.lng]
    })
    this.agmMap.zoom = this.agmMap.zoom - 1;

  }
}
